import { ApolloClient, InMemoryCache, type NormalizedCacheObject } from '@apollo/client';

const dynamicMediaUrl = import.meta.env.VITE_APP_DOMAIN_NAME;

const token = localStorage.getItem('authToken');

// export const GRAPHQL_URI = 'https://prd-oss-api-v2.movingwalls.com/graphql/';
// export const GRAPHQL_URI = 'https://stg-oss-api-v2.movingwalls.com/graphql/';
// export const GRAPHQL_URI = 'http://127.0.0.1:8000/graphql/';
export const GRAPHQL_URI = import.meta.env.VITE_APP_GRAPHQL_URI;
export const MAPBOX_TOKEN = 'pk.eyJ1IjoidGVqYS1zaHJlZSIsImEiOiJjbHo4OWF6ZHgwMGwxMmxzYWxzaTk1YnNiIn0.hpbbzYRq7WOaOPwInekf9w';
export const REACT_APP_PLATFORM_BASE_URL = dynamicMediaUrl ? `https://${dynamicMediaUrl}` : '';
export const MEDIA_URL = dynamicMediaUrl ?? '';

const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  uri: GRAPHQL_URI,
  headers: {
    authorization: token ? `Bearer ${token}` : '',
  },
  cache: new InMemoryCache(),
});

// const client = new ApolloClient({
//   link: new HttpLink({
//     uri: GRAPHQL_URI,
//     headers: {
//       authorization: localStorage.getItem('authToken') ? `Bearer ${localStorage.getItem('authToken')}` : '',
//     },
//     fetch: async (uri, options) => {
//       const response = await fetch(uri, options);
//       const text = await response.text()
//       try {
//         return new Response(text, {
//           status: response.status,
//           statusText: response.statusText,
//           headers: response.headers,
//         });
//       } catch (error) {
//         console.error('Error parsing response:', error);
//         throw error;
//       }
//     },
//   }),
//   cache: new InMemoryCache(),
// });

export { dynamicMediaUrl };
export default client;
